import { createContext, useContext } from 'react';
import { LegalProvisionContextType } from '@raas/shared/src/contexts/types';
import { LEGAL_PROVISION_STATE } from '@raas/shared/src/contexts/utils';

const LegalProvisionContext = createContext<LegalProvisionContextType>({
  legalProvisionContext: null,
  setLegalProvisionContext: (value) => {},
  clearLegalProvisionContext: () => {},
  entityIdHeaderValue: '',
  requiredPermission: 'INTERNAL_ACCESS',
  filteredRoot: null,
  setFilteredRoot: () => '',
  activeSearchMode: false,
  setActiveSearchMode: () => false,
  legalProvisionState: { type: LEGAL_PROVISION_STATE.DEFAULT, elementId: '' },
  setLegalProvisionState: () => {},
  currentTranslationId: null,
  setCurrentTranslationId: () => {},
  legalProvisionTranslationView: {
    originalLanguageId: null,
    setOriginalLanguageId: () => {},
    selectedLanguageId: null,
    setSelectedLanguageId: () => {},
  },
  translationStatuses: {},
  setTranslationStatuses: () => {},
  currentTranslation: null,
  setCurrentTranslation: () => {},
});

export const useLegalProvisionContext = () => {
  const context = useContext(LegalProvisionContext);
  if (!context) {
    throw new Error('useLegalProvisionContext must be used within a LegalProvisionContextProvider');
  }
  return context;
};

export default LegalProvisionContext;
